import { useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import type { CatalogCategoryKindType } from '@econtractor/types';
import EToolTip from 'components/others/EToolTip';
import SolarTuningLineDuotone from 'components/icons/SolarTuningLineDuotone';
import SolarIcon from 'components/icons/SolarIcon';
import { CATALOG_DIR_I18N_NS } from './model/catalogDirApi';
import OffCatalogDirs from './OffCatalogDirs';

interface CatalogAdminDropdownProps {
    kind: CatalogCategoryKindType;
}

const CatalogAdminDropdown = ({ kind }: CatalogAdminDropdownProps) => {
    const { t } = useTranslation([CATALOG_DIR_I18N_NS[kind]]);
    const [dirKind, setDirKind] = useState<CatalogCategoryKindType | null>(null);

    const menu = (
        <Dropdown.Menu className="p-2 shadow-sm warehouse-team-menu" popperConfig={{ strategy: 'fixed' }} renderOnMount>
            <Dropdown.Item
                as="button"
                onClick={(e) => {
                    setDirKind(kind);
                    e.currentTarget.blur();
                }}
            >
                <div className="d-flex align-items-start w-100 text-start">
                    <span className="d-inline-flex align-items-center justify-content-center flex-shrink-0 me-2 item-icon">
                        <SolarIcon name="folder2-open" />
                    </span>
                    <div className="flex-grow-1 min-w-0">
                        <div className="fw-medium">{t('dirs.categoriesTitle')}</div>
                        <small className="text-muted warehouse-team-menu-hint">{t('dirs.categoriesHint')}</small>
                    </div>
                </div>
            </Dropdown.Item>
        </Dropdown.Menu>
    );

    return (
        <>
            <EToolTip title={t('dirs.menuHint')}>
                <span className="d-inline-block">
                    <Dropdown as="span" align="end" className="d-inline-flex">
                        <Dropdown.Toggle
                            as={Button}
                            size="sm"
                            variant="secondary"
                            className="toolbar-menu-btn fs-14 d-inline-flex align-items-center"
                        >
                            <SolarTuningLineDuotone />
                        </Dropdown.Toggle>
                        {typeof document !== 'undefined' ? createPortal(menu, document.body) : menu}
                    </Dropdown>
                </span>
            </EToolTip>

            <OffCatalogDirs kind={dirKind} setKind={setDirKind} />
        </>
    );
};

export default CatalogAdminDropdown;
